import React, { useEffect, useState } from "react";
import Navbar from '../../Componenets/Navbar'
import { useSelector, useDispatch } from "react-redux";
import { fetchUser, updateUser } from "../../Redux/User/userSlice";
import Loader from '../../Componenets/Loader'
import toast, { Toaster } from 'react-hot-toast';
import { fetchOrders , updateFeedback } from "../../Redux/Order/orderSlice";
import { imageUrl } from "../../Config";
import Footer from '../../Componenets/Footer'
import CloseIcon from '@mui/icons-material/Close';

const ProfilePage = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("profile");
  const { user: profile } = useSelector((state) => state.user);
  
  // Initialize orders with additional state for feedback and images
  const { orders: initialOrders } = useSelector((state) => state.order);
  const [orders, setOrders] = useState([]);
  
  useEffect(() => {
    dispatch(fetchOrders());
  }, [dispatch]);

  useEffect(() => {
    if (initialOrders.length > 0) {
      setOrders(initialOrders.map(order => ({
        ...order,
        receiptImage: order.receiptImage ? imageUrl + order?.receiptImage : null,
        feedback: order.feedback || '',
        rating: order.rating || 0,
        isReceived: order.isReceived || false,
        isEditing: false
      })));
    }
  }, [initialOrders]);

  const favorites = useSelector((state) => state.favorites.items);
  const { loading } = useSelector((state) => state.user);

  const [formData, setFormData] = useState({
    first_name: profile?.name || "",
    last_name: profile?.last_name || '',
    email: profile?.email || '',
    phone: profile?.phone || "",
    country: profile?.country || "",
    state: profile?.state || "",
    city: profile?.city || "",
    address: profile?.address || "",
    zip_code: profile?.zip_code || "",
  });

  useEffect(() => {
    if (profile) {
      setFormData({
        first_name: profile?.first_name || "",
        last_name: profile?.last_name || '',
        email: profile?.email || '',
        phone: profile?.phone || "",
        country: profile?.country || "",
        state: profile?.state || "",
        city: profile?.city || "",
        address: profile?.address || "",
        zip_code: profile?.zip_code || "",
      });
    }
  }, [profile]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      dispatch(updateUser(formData));
      toast.success("Profile updated!");
    } catch (error) {
      toast.error('Error occurred while updating profile');
    }
    dispatch(fetchUser());
  };

  // Order confirmation handlers
  const handleImageUpload = (e, orderId) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setOrders(orders.map(order =>
        order.id === orderId
          ? { ...order, receiptImage: reader.result }
          : order
      ));
    };
    reader.readAsDataURL(file);
  };

  const removeImage = (orderId) => {
    setOrders(orders.map(order =>
      order.id === orderId
        ? { ...order, receiptImage: null }
        : order
    ));
  };

  const handleFeedbackChange = (e, orderId) => {
    setOrders(orders.map(order =>
      order.id === orderId
        ? { ...order, feedback: e.target.value }
        : order
    ));
  };


  const markAsReceived = async (orderId) => {
    try {
      const order = orders.find(o => o.id === orderId);
      const formData = new FormData();
      formData.append('feedback', order.feedback);
      formData.append('rating', order.rating);
      if (order.receiptImage) {
        if (order.receiptImage.startsWith('data:image')) {
          const blob = await fetch(order.receiptImage).then(res => res.blob());
          formData.append('imageUrl', blob, 'receipt.jpg');
        } else {
          formData.append('imageUrl', order.receiptImage);
        }
      }
       dispatch(updateFeedback({ orderId, formData }));
      
      toast.success("Order marked as received!");
      
      setOrders(orders.map(order =>
        order.id === orderId
          ? { ...order }
          : order
      ));
    } catch (error) {
      toast.error("Failed to update order status");
      console.error("Error updating feedback:", error);
    }
  };


  return (
    <>
      <div className="container-fluid d-flex justify-content-center align-items-center vh-100">
        <Toaster />
        {loading && <Loader />}
        <div className="row shadow-lg rounded-4" style={{ width: "80%", background: "#fff", height: "80%", marginTop: '5%' }}>

          {/* Sidebar Navigation */}
          <div className="col-md-3 p-3" style={{ background: "#b3697b", borderRadius: "15px 0 0 15px" }}>
            <h4 className="text-white text-center mb-4">My Account</h4>
            <ul className="nav flex-column">
              <li className="nav-item">
                <button className={`nav-link w-100 text-white ${activeTab === "profile" ? "active-tab" : ""}`} onClick={() => setActiveTab("profile")}>
                  Profile
                </button>
              </li>
              <li className="nav-item">
                <button className={`nav-link w-100 text-white ${activeTab === "orders" ? "active-tab" : ""}`} onClick={() => setActiveTab("orders")}>
                  Orders
                </button>
              </li>
              <li className="nav-item">
                <button className={`nav-link w-100 text-white ${activeTab === "favorites" ? "active-tab" : ""}`} onClick={() => setActiveTab("favorites")}>
                  Favorites
                </button>
              </li>
            </ul>
          </div>

          {/* Main Content */}
          <div className="col-md-9 p-4 d-flex flex-column" style={{ height: "100%", overflowY: "scroll" }}>
            <div className="tab-content">

              {activeTab === "profile" && (
                <div>
                  <h4 className="mb-3 text-center" style={{ color: "#b3697b" }}>Edit Profile</h4>
                  <form onSubmit={handleSubmit}>
                    {Object.keys(formData).map((key) => (
                      <div key={key} className="mb-3">
                        <label className="form-label">{key.replace("_", " ").toUpperCase()}</label>
                        <input
                          type={key === 'zip_code' || key === 'phone' ? 'number' : 'text'}
                          className="form-control"
                          name={key}
                          disabled={key === 'email'}
                          value={formData[key]}
                          onChange={handleChange}
                        />
                      </div>
                    ))}
                    <button type="submit" className="btn w-100" style={{ background: "#f5a3b7", color: "white" }}>Update Profile</button>
                  </form>
                </div>
              )}

              {/* Orders Tab */}
              {activeTab === "orders" && (
                <div>
                  <h4 className="mb-3 text-center" style={{ color: "#b3697b" }}>My Orders</h4>

                  {orders.length > 0 ? (
                    orders.map((order) => (
                      <div key={order.id} className="card p-3 mb-3 shadow-sm">
                        <h5 className="mb-1">Order #{order.id}</h5>
                        <p className="text-muted">Status: <strong>{order.paymentStatus}</strong></p>
                        <p className="text-muted">Delivery Status: <strong>{order?.status || 'To Ship'}</strong></p>
                        <p className="text-muted">Total Amount: <strong>${order.totalAmount.toFixed(2)}</strong></p>

                        <h6 className="mt-3">Items:</h6>
                        <ul className="list-group">
                          {JSON.parse(order?.products).map((product, index) => (
                            <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                              <div>
                                <img
                                  src={imageUrl + product.Product?.imageUrl || "https://via.placeholder.com/50"}
                                  alt={product?.Product.name}
                                  width="50"
                                  className="rounded me-2"
                                />
                                {product?.Product?.name} (x{product.quantity})
                              </div>
                              <span className="badge bg-primary">${(parseFloat(product?.Product?.price) * product.quantity).toFixed(2)}</span>
                            </li>
                          ))}
                        </ul>

                        {/* Delivery Confirmation Section */}
                        {(order?.status === 'delivered' || order?.status == 'received') && (
                          <div className="mt-4 border-top pt-3">
                            <h6 className="mb-3">Confirm Delivery & Feedback</h6>

                            <div className="mb-3">
                              <label className="form-label">Upload Receiving Proof (Optional)</label>
                              <div className="d-flex align-items-center">
                                <input
                                  type="file"
                                  className="form-control"
                                  accept="image/*"
                                  onChange={(e) => handleImageUpload(e, order.id)}
                                  style={{ maxWidth: '300px' }}
                                  id={`file-upload-${order.id}`}
                                />
                                {order.receiptImage && (
                                  <div className="position-relative ms-3">
                                    <img
                                      src={order.receiptImage}
                                      alt="Receipt preview"
                                      className="rounded"
                                      width="60"
                                      height="60"
                                      style={{ objectFit: 'cover' }}
                                    />
                                    <button
                                      className="btn btn-sm btn-danger position-absolute top-0 end-0 translate-middle"
                                      onClick={() => removeImage(order.id)}
                                      style={{ padding: '0.15rem 0.35rem', borderRadius: '50%' }}
                                    >
                                      <CloseIcon fontSize="10px" />
                                    </button>
                                  </div>
                                )}
                              </div>
                              <small className="text-muted">Upload a photo of your received items</small>
                            </div>

                            {/* Feedback Section */}
                            <div className="mb-3">
                              <label className="form-label">Your Feedback</label>
                              <textarea
                                className="form-control"
                                rows="3"
                                placeholder="How was your experience with these products?"
                                value={order.feedback || ''}
                                onChange={(e) => handleFeedbackChange(e, order.id)}
                                disabled={order.isReceived && !order.isEditing}
                              ></textarea>
                            </div>

                            <button
                                  className="btn btn-primary"
                                  onClick={() => markAsReceived(order.id)}
                                >
                                  <i className="bi bi-check-circle me-2"></i>
                                  submit
                                </button>

                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <p className="text-center text-muted">No orders found.</p>
                  )}
                </div>
              )}

              {/* Favorites Tab */}
              {activeTab === "favorites" && (
                <div>
                  <h4 className="mb-3 text-center" style={{ color: "#b3697b" }}>Favorite Items</h4>
                  {favorites?.map((item) => (
                    <div key={item.id} className="d-flex align-items-center border p-2 mb-2 rounded">
                      <img src={imageUrl + item.imageUrl} alt={item.name} className="rounded" width="50" />
                      <div className="ms-3">
                        <p className="mb-1">{item.name}</p>
                        <p className="text-primary fw-bold">${item.price}</p>
                      </div>
                    </div>
                  ))}
                  {favorites.length === 0 && (
                    <h5 className="d-flex justify-content-center">
                      You have no favorite items yet. Click on the heart icon to add an item to your favorites
                    </h5>
                  )}
                </div>
              )}

            </div>
          </div>
          <style>{`
            .nav-link {
              padding: 10px;
              transition: 0.3s;
              font-size: 16px;
              border-radius: 8px;
            }
            .nav-link:hover {
              background: rgba(255, 255, 255, 0.2);
            }
            .active-tab {
              background: white !important;
              color: #f5a3b7 !important;
              font-weight: bold;
            }
          `}</style>

        </div>
      </div>
      <Footer />
    </>
  );
};

export default ProfilePage;